import { InterviewFeedbackStore } from "@hireroo/app-store/view-domain/InterviewFeedback";
import { TechnicalCommentPrompt } from "@hireroo/app-store/widget/e/TechnicalCommentPrompt";

export const startSubscribeReviewedSpot = () => {
  return TechnicalCommentPrompt.subscribeReviewedSpotKey(reviewedSpot => {
    InterviewFeedbackStore.updateInterview(reviewedSpot);
  });
};
